<template>
    <div>
        <b-modal v-if="ptInfo" centered ref="savePointModal" @hidden="hideSavePointModal">
            <template #modal-header>
                <h5 class="mb-0">{{ "저장 관제점 관리" }}</h5>
            </template>
            <template #modal-footer>
                <div style="display: flex; flex: 1">
                    <button type="button" class="btn btn-primary ctrl-modal-btn" @click="savePoint">
                        {{ "저장" }}
                    </button>
                    <button type="button" class="btn btn-secondary ctrl-modal-btn" @click="hideSavePointModal">
                        {{ "닫기" }}
                    </button>
                </div>
            </template>
            <div class="row">
                <div class="col-md-7">
                    <label for="ptInfo">연결된 관제점(*)</label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="관제점을 찾아서 연결해주세요."
                        :value="ptInfo.ptAddr"
                        disabled
                    />
                </div>
                <!-- @keydown.enter="enterSelectPoint" -->
                <div class="col-md-2">
                    <label for="ptIdx">관제점 ID</label>
                    <input :value="ptInfo.ptIdx" type="text" class="form-control" placeholder="-" disabled />
                </div>
                <div class="col-md-3 select-point-btn">
                    <button v-b-toggle.rltnPointSideBar type="button" class="btn btn-primary" style="flex: 1">
                        관제점 선택
                    </button>
                </div>
            </div>
            <b-sidebar
                v-model="sideBar"
                ref="rltnPointSideBar"
                id="rltnPointSideBar"
                bg-variant="white"
                backdrop-variant="secondary"
                width="50vw"
                @hidden="closeSidebar"
                no-header
                shadow
                right
                backdrop
            >
                <div v-if="sideBar" style="padding: 1rem; height: 100%">
                    <SearchComponent
                        :tableMaxHeight="'75vh'"
                        :optionTableHeight="'67vh'"
                        @select-point="selectPoint"
                        @close="closeSidebar"
                    />
                </div>
            </b-sidebar>
        </b-modal>
    </div>
</template>

<script>
import SearchComponent from "@src/views/component/v2.1/PointSearch/Search.vue";

export default {
    props: ["nodeInfo"],
    components: {
        SearchComponent,
    },
    data() {
        return {
            ptInfo: null,
            inputPoint: false,
            sideBar: false,
        };
    },
    computed: {},
    mounted() {
        this.setData();
    },
    destroyed() {
        this.ptInfo = null;
    },
    methods: {
        // setData(data) {
        //     if (data) {
        //         this.ptInfo = data;
        //     } else {
        //         this.ptInfo = this.initData();
        //     }
        // },
        showSideBar() {
            this.sideBar = true;
        },
        closeSidebar() {
            this.$refs.rltnPointSideBar.hide();
            this.sideBar = false;
        },
        async showSavePointModal() {
            await this.setData();
            this.$refs.savePointModal.show();
        },
        async hideSavePointModal() {
            await this.$refs.savePointModal.hide();
            this.ptInfo = null;
        },
        enterSelectPoint() {},
        setData() {
            this.ptInfo = {
                ptIdx: this.nodeInfo.savePtIdx || null,
                ptAddr: this.nodeInfo.savePtAddr || null,
            };
        },
        selectPoint(data) {
            if (!this.isEmpty(data)) {
                this.ptInfo.ptAddr = data.ptAddr;
                this.ptInfo.ptIdx = data.ptIdx;
            }
            this.$refs.rltnPointSideBar.hide();
        },
        savePoint() {
            this.$emit("save", this.ptInfo);
        },
    },
};
</script>

<style scoped>
.select-point-btn {
    display: flex;
    flex: 1;
    align-items: flex-end;
    justify-content: flex-end;
}
.ctrl-modal-btn {
    flex: 1;
    margin: 0px 5px 0px 5px;
}
</style>
